if (!customElements.get('aurrelle-floating-reviews')) {
  customElements.define('aurrelle-floating-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.home = this.parentNode;
      this.toggle = this.querySelector('.afr-toggle');
      this.content = this.querySelector('.afr-content');
      this.reviews = this.mixReviews([...this.querySelectorAll('.afr-review')]);
      this.index = 0;
      this.clouds = document.createElement('div');
      this.clouds.className = 'afr-clouds';
      this.clouds.dir = this.querySelector('.afr-card').dir;
      this.cloudClose = this.querySelector('.afr-close').cloneNode(true);
      this.cloudClose.classList.add('afr-cloud-close');
      this.append(this.clouds, this.cloudClose);
      this.active = false;
      this.appearances = 0;
      this.dismissed = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.productPage = this.dataset.page === 'product' && this.dataset.product === this.dataset.productScope;
      this.cartPage = this.dataset.page === 'cart';
      try { this.dismissed = sessionStorage.getItem('aurrelle_reviews_dismissed') === 'true'; } catch (_) {}
      this.toggle.addEventListener('click', () => this.expand(this.content.hidden));
      this.querySelectorAll('.afr-close').forEach(button => button.addEventListener('click', () => {
        this.dismissed = true;
        clearTimeout(this.timer);
        clearInterval(this.rotation);
        try { sessionStorage.setItem('aurrelle_reviews_dismissed', 'true'); } catch (_) {}
        this.sync();
      }));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('.afr-navigation').hidden = this.reviews.length < 2;
      this.show(0);
      this.expand(true);
      this.drawerObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      const drawer = document.getElementById('CartDrawer');
      if (drawer) this.drawerObserver.observe(drawer, {attributes:true, attributeFilter:['hidden','open'], childList:true, subtree:true});
      this.pageObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.pageObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden','open','aria-hidden','style']});
      this.scrollHandler = () => {
        if (!this.tick) this.tick = requestAnimationFrame(() => { this.tick = null; this.sync(); });
      };
      window.addEventListener('scroll', this.scrollHandler, {passive:true});
      window.addEventListener('resize', this.scrollHandler);
      this.rotation = setInterval(() => {
        if ((this.dataset.inCart === 'true' || this.cartPage) && !this.hidden && !this.paused() && !this.reducedMotion) this.show(this.index + 1);
      }, 5000);
      if (this.productPage) this.timer = setTimeout(() => this.appear(), Number(this.dataset.delay) * 1000);
      this.sync();
    }
    mixReviews(reviews) {
      const pool = [...reviews];
      for (let i = pool.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      const language = review => review.dataset.reviewLanguage || (/\p{Script=Arabic}/u.test(review.querySelector('blockquote').textContent) ? 'ar' : 'en');
      const mixed = [];
      while (pool.length) {
        const previous = mixed[mixed.length - 1];
        let index = previous ? pool.findIndex(review => language(review) !== language(previous)) : 0;
        mixed.push(pool.splice(Math.max(index, 0), 1)[0]);
      }
      return mixed;
    }
    paused() {
      return this.matches(':hover') || this.contains(document.activeElement) || document.hidden;
    }
    expand(open) {
      this.content.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
    }
    show(index) {
      if (!this.reviews.length) return;
      this.index = (index + this.reviews.length) % this.reviews.length;
      this.reviews.forEach((review, i) => { review.hidden = i !== this.index; });
      this.querySelector('[data-count]').textContent = (this.index + 1) + ' / ' + this.reviews.length;
    }
    appear() {
      if (this.dismissed || this.appearances >= 4) return;
      if (this.dataset.inCart === 'true' || document.hidden) {
        this.timer = setTimeout(() => this.appear(), 1000);
        return;
      }
      this.clouds.replaceChildren();
      this.reviews.slice(0, Math.min(3, this.reviews.length)).forEach((_, i) => {
        const cloud = this.reviews[(this.appearances * 3 + i) % this.reviews.length].cloneNode(true);
        cloud.hidden = false;
        cloud.removeAttribute('data-shopify-editor-block');
        cloud.classList.add('afr-cloud');
        cloud.style.setProperty('--afr-stagger', i + 's');
        const section = document.querySelector('[data-review-stories]');
        if (section) {
          const link = document.createElement('a');
          link.className = 'afr-cloud-link';
          link.href = '#aurrelle-customer-voices';
          link.textContent = this.querySelector('.afr-toggle-label').textContent;
          link.addEventListener('click', () => {
            const story = document.getElementById('aurrelle-review-' + (((this.appearances - 1) * 3 + i) % this.reviews.length));
            if (story) story.scrollIntoView({block:'nearest', inline:'start', behavior:this.reducedMotion ? 'auto' : 'smooth'});
          });
          cloud.append(link);
        }
        this.clouds.append(cloud);
      });
      this.appearances += 1;
      this.active = true;
      this.dataset.phase = 'visible';
      this.sync();
      if (!this.reducedMotion) this.timer = setTimeout(() => this.disappear(), 8500);
    }
    disappear() {
      if (this.paused() || this.dataset.inCart === 'true') {
        this.timer = setTimeout(() => this.disappear(), 1000);
        return;
      }
      this.dataset.phase = 'leaving';
      this.timer = setTimeout(() => {
        this.active = false;
        this.sync();
        if (this.appearances < 4) this.timer = setTimeout(() => this.appear(), [9000,12000,10000][this.appearances - 1]);
      }, 2550);
    }
    mountVoices() {
      const section = document.querySelector('[data-review-stories]');
      if (!section || section.dataset.mounted === 'true') return;
      section.dataset.mounted = 'true';
      const track = section.querySelector('[data-voices-track]');
      this.reviews.forEach((review, index) => {
        const story = review.cloneNode(true);
        story.hidden = false;
        story.className = 'avr-story';
        story.removeAttribute('data-shopify-editor-block');
        story.id = 'aurrelle-review-' + index;
        const quote = story.querySelector('blockquote');
        const text = quote.textContent.trim();
        if (text.length > 220) {
          const details = document.createElement('details');
          details.className = 'avr-full-review';
          const summary = document.createElement('summary');
          summary.textContent = section.dataset.readMore;
          const preview = document.createElement('span');
          preview.className = 'avr-review-preview';
          preview.textContent = text.slice(0, 200).replace(/\s+\S*$/, '') + '…';
          const full = document.createElement('span');
          full.textContent = text;
          details.append(summary, full);
          details.addEventListener('toggle', () => { preview.hidden = details.open; });
          quote.replaceChildren(preview, details);
        }
        track.append(story);
      });
      section.hidden = !this.reviews.length;
      const ratings = this.reviews.map(review => {
        const stars = review.querySelector('.afr-stars');
        return stars ? [...stars.textContent].filter(star => star === '★').length : null;
      }).filter(rating => rating !== null && rating >= 1 && rating <= 5);
      const summary = section.querySelector('[data-voices-score]');
      summary.hidden = !ratings.length;
      if (ratings.length) {
        const locale = document.documentElement.lang || 'en';
        const average = ratings.reduce((total, rating) => total + rating, 0) / ratings.length;
        const label = section.dataset.scoreTemplate.replace('__RATING__', average.toLocaleString(locale, {minimumFractionDigits:1, maximumFractionDigits:1})).replace('__COUNT__', ratings.length.toLocaleString(locale));
        const stars = document.createElement('span');
        stars.className = 'avr-average-stars';
        stars.dir = 'ltr';
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', label.split(' · ')[0]);
        for (let i = 0; i < 5; i += 1) {
          const star = document.createElement('span');
          star.textContent = '★';
          star.setAttribute('aria-hidden', 'true');
          star.style.setProperty('--star-fill', Math.min(100, Math.max(0, (average - i) * 100)) + '%');
          stars.append(star);
        }
        const count = document.createElement('span');
        count.className = 'avr-review-count';
        count.textContent = label.split(' · ').slice(1).join(' · ');
        const ratingRow = document.createElement('span');
        ratingRow.className = 'avr-rating-row';
        const numericRating = document.createElement('span');
        numericRating.className = 'avr-numeric-rating';
        numericRating.dir = 'ltr';
        numericRating.setAttribute('aria-hidden', 'true');
        numericRating.textContent = average.toFixed(1) + '/5';
        ratingRow.append(stars, numericRating);
        summary.replaceChildren(ratingRow, count);
      }
      let heightFrame;
      const fitVisibleCards = () => {
        if (heightFrame) return;
        heightFrame = requestAnimationFrame(() => {
          heightFrame = null;
          const stories = [...track.children];
          if (!stories.length || !track.clientWidth) return;
          const style = getComputedStyle(track);
          const gap = parseFloat(style.gap);
          const step = stories[0].getBoundingClientRect().width + gap;
          const index = Math.max(0, Math.round(Math.abs(track.scrollLeft) / step));
          const count = Math.max(1, Math.floor((track.clientWidth + gap) / step));
          const visible = stories.slice(index, index + count);
          const height = Math.ceil(Math.max(...visible.map(story => story.getBoundingClientRect().height)) + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
          if (height > 0 && track.style.height !== height + 'px') track.style.height = height + 'px';
        });
      };
      track.addEventListener('scroll', fitVisibleCards, {passive:true});
      const sizes = new ResizeObserver(fitVisibleCards);
      sizes.observe(track);
      [...track.children].forEach(story => sizes.observe(story));
      fitVisibleCards();
      const advance = direction => {
        const first = track.firstElementChild;
        if (!first) return;
        const amount = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left: direction * amount * (section.dir === 'rtl' ? -1 : 1), behavior:this.reducedMotion ? 'auto' : 'smooth'});
      };
      section.querySelector('[data-voices-next]').addEventListener('click', () => advance(1));
      section.querySelector('[data-voices-previous]').addEventListener('click', () => advance(-1));
      section.querySelector('.avr-controls').hidden = this.reviews.length < 2;
      let stopped = this.reducedMotion;
      let pauseUntil = 0;
      let transitioning = false;
      const pauseButton = section.querySelector('[data-voices-pause]');
      const updatePause = () => {
        pauseButton.textContent = stopped ? '▶' : 'Ⅱ';
        pauseButton.setAttribute('aria-label', stopped ? section.dataset.resume : section.dataset.pause);
        pauseButton.setAttribute('aria-pressed', String(stopped));
      };
      pauseButton.addEventListener('click', () => {
        stopped = !stopped;
        pauseUntil = 0;
        updatePause();
      });
      updatePause();
      const hold = () => { pauseUntil = Date.now() + 10000; };
      track.addEventListener('pointerdown', hold, {passive:true});
      track.addEventListener('keydown', hold);
      section.querySelector('[data-voices-next]').addEventListener('click', hold);
      section.querySelector('[data-voices-previous]').addEventListener('click', hold);
      clearInterval(this.voicesRotation);
      this.voicesRotation = setInterval(() => {
        if (!section.isConnected) { clearInterval(this.voicesRotation); return; }
        const rect = track.getBoundingClientRect();
        if (stopped || this.reducedMotion || transitioning || this.reviews.length < 2 || document.hidden || Date.now() < pauseUntil || track.matches(':hover') || track.contains(document.activeElement) || track.querySelector('details[open]') || rect.top >= window.innerHeight || rect.bottom <= 0) return;
        const stories = [...track.children];
        const step = stories[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const index = Math.min(stories.length - 1, Math.round(Math.abs(track.scrollLeft) / step));
        const atEnd = Math.abs(track.scrollLeft) >= track.scrollWidth - track.clientWidth - 2;
        const visibleCount = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).gap)) / step));
        const entering = stories[atEnd ? 0 : Math.min(stories.length - 1, index + visibleCount)];
        transitioning = true;
        stories[index].classList.add('avr-leaving');
        setTimeout(() => {
          if (atEnd) track.scrollTo({left:0, behavior:'instant'});
          else advance(1);
          entering.animate([{opacity:0},{opacity:1}], {duration:700, easing:'ease-out'});
          setTimeout(() => { stories[index].classList.remove('avr-leaving'); transitioning = false; }, 850);
        }, 350);
      }, 3000);
    }
    sync() {
      this.mountVoices();
      const drawer = document.getElementById('CartDrawer');
      const inDrawer = drawer && !drawer.hidden && drawer.hasAttribute('open');
      const footer = inDrawer && drawer.querySelector('.drawer__footer:not(.hidden)');
      const checkout = this.cartPage && document.querySelector('button[name="checkout"]');
      const cartTarget = checkout && checkout.closest('.cart__sidebar');
      const target = footer || cartTarget || this.home;
      if (this.parentNode !== target) {
        if (target === this.home) target.append(this);
        else { target.prepend(this); this.expand(true); }
      }
      this.dataset.inCart = String(Boolean(footer) || this.cartPage);
      const cartEmpty = this.cartPage && !document.querySelector('input[name="updates[]"]');
      const modal = [...document.querySelectorAll('modal-element[open], menu-drawer[open], search-drawer[open], .kl-private-reset-css-Xuajs1 [role="dialog"]')].some(element => {
        const style = getComputedStyle(element);
        return element.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
      });
      const voices = document.querySelector('[data-review-stories]');
      const voicesRect = voices && !voices.hidden && voices.getBoundingClientRect();
      const readingVoices = voicesRect && voicesRect.top < window.innerHeight && voicesRect.bottom > 0;
      this.hidden = this.dismissed || !this.reviews.length || Boolean(modal) || !(footer || (this.cartPage && !cartEmpty) || (this.productPage && this.active && !readingVoices));
      if (!footer && window.innerWidth < 768 && !this.cartPage) {
        let offset = 100;
        document.querySelectorAll('product-sticky-form, .mobile-dock').forEach(element => {
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          if (rect.height && rect.bottom >= window.innerHeight - 2 && rect.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none') offset = Math.max(offset, window.innerHeight - rect.top + 12);
        });
        this.style.setProperty('--afr-bottom', offset + 'px');
      }
    }
  });
}
